/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import React from "react";

export interface Column {
  key: string;
  label: string;
  align?: "left" | "center" | "right" | string | undefined | null;
}

export interface GoldDynamicTablesProps {
  columns: Column[];
  data: Record<string, any>[];
}

export default function GoldDynamicTables({
  columns,
  data,
}: GoldDynamicTablesProps) {
  return (
    <div className="relative w-full rounded-xl border border-gray-800 bg-black/40 max-h-400 sm:max-h-157.5 overflow-auto scrollbar-none">
      <table className="w-full border-collapse">
        {/* Table Head */}
        <thead className="sticky top-0 bg-[#1a1a1a] text-gray-200 text-sm">
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className={`px-4 sm:px-10 py-3 font-medium ${col.align === "center" ? "text-center" : col.align === "right" ? "text-right" : "text-left"}`}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        {/* Table Body */}
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="border-b border-gray-800 last:border-0 text-white text-sm"
            >
              {columns.map((col) => {
                const value = row[col.key];

                const isChange =
                  typeof value === "string" &&
                  (value.startsWith("+") || value.startsWith("-"));

                return (
                  <td
                    key={col.key}
                    className={`px-4 sm:px-10 py-4 ${col.align === "center" ? "text-center" : col.align === "right" ? "text-right" : "text-left"} ${isChange ? (value.startsWith("+") ? "text-green-500" : "text-red-500") : ""}`}
                  >
                    {value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
